<script>
const configComp = ["SELECT_V2", "CHECKBOX", "RADIO"]
import { copy } from '../utils/tools'
export default {
    name: 'RulesDialog',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        formItems: {
            type: Array,
            default: () => []
        },
        formRules: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        value(v) {
            this.dialogVisible = v
            if(v) {
                this.init()
                const keyMapItem = {}
                const formItemsList = copy(this.formItems.filter(item => configComp.includes(item.typeId)))
                formItemsList.forEach(item => (keyMapItem[item.__vModel__] = item))
                const keys = copy(this.form.keys)
                keys.forEach(item => {
                    const newItem = keyMapItem[item.formItem.__vModel__]
                    let opts = item.formItem.options || item.formItem.__slot__.options
                    let newOpts = newItem.options || newItem.__slot__.options
                    const len = opts.length
                    const newLen = newOpts.length
                    if (len !== newLen) {
                    //options 有变动
                        if (len > newLen) {
                            //options 有子项被删除 判断子项是否被配置规则如果被配置变更rule数据
                            const oldRuleOpts = item.opsRules.map(
                                (rule) => rule.split("$")[1]
                            )
                            const newRuleOpts = newOpts.map((opt) => opt.value)
                            const delRuleIndex = []
                            oldRuleOpts.forEach((val, index) => {
                                if (!newRuleOpts.includes(val)) {
                                    delRuleIndex.push(index)
                                }
                            })
                            if (delRuleIndex.length)
                            item.opsRules = item.opsRules.filter(
                                (val, index) => !delRuleIndex.includes(index)
                            )
                        }
                        item.formItem = copy(newItem)
                    }
                })
                this.form.keys = keys
            }
        }
    },
    data() {
        return {
            dialogVisible: false,
            form: {
                keys: []
            },
            result: null,
            selectedItems: []
        }
    },
    methods: {
        init() {
            this.form = {
                keys: copy(this.formRules)
            }
        }
    },
    created() {
        this.init()
    },
    render() {
        const formItemsList = this.formItems.filter(item => configComp.includes(item.typeId))
        const handleAdd = () => {
            const { keys } = this.form
            if(keys.length === formItemsList.length) {
                this.$message.warning("可设置显隐规则组件已超出数量！")
                return
            }
            this.form.keys = this.form.keys.concat({ formItem: "" })
        }
        const handleRemove = (index, subIndex) => {
            const keys = copy(this.form.keys)
            if (typeof subIndex === "number") {
                const ops = keys[index].formItem.options || keys[index].formItem.__slot__.options
                keys[index].opsRules[subIndex] = ""
                this.form.keys = ops.length === 0 ? keys.filter((_, i) => index !== i) : keys
                if (ops.length === 0) {
                    this.selectedItems = this.selectedItems.filter(
                        (id) => id !== keys[index].formItem.__vModel__
                    )
                }
            } else {
                this.form.keys = keys.filter((_, i) => index !== i)
                this.selectedItems = this.selectedItems.filter(
                    (id) => id !== keys[index].formItem.__vModel__
                )
            }
        }
        const handleItemChange = (index, value, label, fieldId) => {
            const keys = copy(this.form.keys)
            const { __vModel__: id, typeId } = keys[index].formItem
            if(label) {
                if (!keys[index].opsRules) keys[index].opsRules = []
                const rule = keys[index].opsRules[value]
                keys[index].opsRules[value] = rule && rule.split("$")[2] ? rule.split('$').slice(0, 2).join('$') + '$' + fieldId.join('&') : `${id}$${label}^${typeId}$${fieldId}`
            } else {
                if (id) {
                    this.selectedItems.splice(this.selectedItems.indexOf(id), 1)
                } else {
                    this.selectedItems.push(value);
                }
                keys[index].formItem = copy(formItemsList.filter((item) => item.__vModel__ === value)[0])
            }
            this.form.keys = keys
        }
        const filteredOptions = (fieldId) => {
            //过滤 可选组件列表数据 避免重复选中配置规则
            return formItemsList.filter(
                ({ __vModel__ }) => fieldId === __vModel__ || !this.selectedItems.includes(__vModel__)
            )
        }
        const onDeselect = (value, index, subIndex) => {
            const keys = copy(this.form.keys)
            const _keyStr = keys[index].opsRules[subIndex]
            const match = _keyStr.includes("$" + value) ? "$" + value : "&" + value
            keys[index].opsRules[subIndex] = match.includes("$") ? "" : _keyStr.replace(match, "")
            this.form.keys = keys
        }
        const computedShowItem = (data, formItem) => {
            let _data = []
            try {
                data.forEach((item, index) => {
                    if (item.__vModel__ === formItem.__vModel__) throw new Error(index)
                })
            } catch (err) {
                _data = data.slice(+err.message + 1)
            }
            return _data
        }
        const getOptions = item => {
            if(item.formItem) {
                return item.formItem.options || item.formItem.__slot__.options
            } else {
                return []
            }
        }
        const handelConfirm = () => {
            const { keys } = this.form
            const rules = keys.filter((item) => item.opsRules && item.opsRules.length)
            if (keys.length && rules.length) {
                this.$emit('setRules', rules)
                this.$emit('input', false)
            } else {
                this.$message.warning("请先添加并设置显隐规则！")
            }
        }
        return (
            <el-dialog 
                title="设置显隐规则" 
                width="60%" 
                visible={this.value}
                beforeClose={() => this.$emit('input', false) }
                close-on-click-modal         
            >
                {
                    formItemsList.length ? (
                        <el-form ref="form" props={{ model: this.form }}>
                            {
                                this.form.keys?.map((item, index) => {
                                    return (
                                        <el-form-item key={index} label="组件">
                                            <el-select 
                                                placeholder="请选择组件"
                                                onChange={value => handleItemChange(index, value)}
                                                value={item.formItem ? item.formItem.__vModel__ : undefined}
                                            >
                                                {
                                                    filteredOptions(item.formItem ? item.formItem.__vModel__ : undefined).map((item, index) => {
                                                        return (
                                                            <el-option key={index} value={item.__vModel__} label={item.__config__.label}></el-option>
                                                        )
                                                    })
                                                }
                                            </el-select>
                                            <i class="el-icon-delete delete" onClick={() => handleRemove(index)}></i>
                                            {
                                                getOptions(item).map((option, subIndex) => {
                                                    return (
                                                        <el-row key={option.label}>
                                                            <el-col offset={2} span={12}>
                                                                <el-form-item key={index} label="选择">
                                                                    <el-input size="small" disabled value={option.label} style="width: 60%; margin-right: 8px">
                                                                        <span slot="suffix">时</span>
                                                                    </el-input>
                                                                </el-form-item>
                                                            </el-col>
                                                            <el-col span={10}>
                                                                <el-form-item key={index} label="显示">
                                                                    <el-select
                                                                        size="small"
                                                                        placeholder="请选择组件"
                                                                        multiple
                                                                        onChange={value => handleItemChange(index, subIndex, option.label, value)}
                                                                        onRemoveTag={value => onDeselect(value, index, subIndex)}
                                                                        value={item.opsRules && item.opsRules[subIndex] ? item.opsRules[subIndex].split('$')[2] ? item.opsRules[subIndex].split('$')[2].split('&') : [] : []}
                                                                    >
                                                                        {
                                                                            computedShowItem(this.formItems, item.formItem).map(obj => {
                                                                                return <el-option key={obj.__vModel__} value={obj.__vModel__} label={obj.__config__.label}></el-option>
                                                                            })
                                                                        }
                                                                    </el-select>
                                                                    <i class="el-icon-delete delete" onClick={() => handleRemove(index, subIndex)}></i>
                                                                </el-form-item>
                                                            </el-col>
                                                        </el-row>
                                                    )
                                                })
                                            }
                                        </el-form-item>
                                    )
                                })
                            }
                            <el-form-item>
                                <el-button onClick={handleAdd} style="width: 30%" size="small" icon="el-icon-plus">添加</el-button>
                            </el-form-item>
                        </el-form>
                    ) : <el-empty description="暂无可配置规则表单组件，当前仅下拉选择、单选框组、多选框组表单组件支持配置规则" />
                }
                <template slot="footer">
                    <span>
                        <el-button onClick={() => this.$emit('input', false) }>取 消</el-button>
                        <el-button type="primary" onClick={() => handelConfirm() }>确 定</el-button>
                    </span>
                </template>
            </el-dialog>
        )
    }
}
</script>
<style scoped>
.delete {
    cursor: pointer;
    margin: 0 10px;
}
</style>